import { action, observable } from 'mobx';

import ApiService from '@app/Services/ApiService';
import { ApiUrls } from '@app/AppConstants';
import { NotificationHandler } from '@app/Components/ToastNotification';
import { PlanningLicenseInactivationModel, PlanningLicenseInactivationValidationResult } from '@app/Models';
import { modalService } from '@app/Components/Modal';
import { PromiseCompletion } from '@app/Classes/PromiseCompletion';

export type ChangeLicenseInactivationCallback = (personId: string) => void;

export type LicenseInactivationStoreParams = {
    personId: string;
    licenseId: string;
    onChangeLicenseInactivationHandler: ChangeLicenseInactivationCallback;
};

export class LicenseInactivationStore{
    @observable personLicenseInactivations: PlanningLicenseInactivationModel[];
    private personId: string;
    private onChangeLicenseInactivationHandler: ChangeLicenseInactivationCallback;
    public loader: PromiseCompletion = new PromiseCompletion();
    
    constructor(params: LicenseInactivationStoreParams){
        this.personId = params.personId;
        this.onChangeLicenseInactivationHandler = params.onChangeLicenseInactivationHandler;
        this.loadLicenseInactivations(params.licenseId);
    }
    
    @action.bound
    async loadLicenseInactivations(licenseId: string) {
        const params = { personLicenseId: licenseId };
        const { data: inactivations } = await  ApiService.getData(ApiUrls.PersonLicenseInactivationUrl, params, { completion: this.loader });
        this.personLicenseInactivations = inactivations;
    }
    
    @action.bound
    async deleteLicenseInactivation(inactivationId: string, licenseId: string) {
        await ApiService.deleteData(ApiUrls.PersonLicenseInactivationUrl + '?planningLicenseInactivationId=' + inactivationId);
        NotificationHandler.showSuccess('License Inactivation was deleted', 'Success message');
        if (this.personId) {
            this.loadLicenseInactivations(licenseId);
            this.onChangeLicenseInactivationHandler(this.personId);
        }
    }

    @action.bound
    async updateLicenseInactivation(params: PlanningLicenseInactivationModel) {
        const { data: result } = await ApiService.putTypedData<PlanningLicenseInactivationValidationResult>(ApiUrls.PersonLicenseInactivationUrl, params);
        
        if (result.hasErrors && result.errors) {
            await modalService.showInformation(result.errors.join('\r\n '));
        } else {
            NotificationHandler.showSuccess('Person Planing License Inactivation was updated', 'Success message');
        }

        const updatedLicense = result.value;
        if (updatedLicense) {
            this.personLicenseInactivations = this.personLicenseInactivations.map((item: PlanningLicenseInactivationModel) => item.id === updatedLicense.id ? updatedLicense : item);
        }
    }
}